<template>
<div>
  <form v-on:submit.prevent>
    <autocomplete :input-attrs="{ placeholder: 'Commune de...' }" :value="selected" :items="results" :get-label="getLabel" :component-item='communeTemplate' :auto-select-one-item="true" @update-items="search" @item-selected="communeSelected" />
  </form>
</div>
</template>

<script>
// https://github.com/paliari/v-autocomplete
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
import axios from 'axios'
import CommuneTemplate from './SearchCommuneTemplate.vue'
export default {
  name: 'SearchCommune',
  components: {
    Autocomplete
  },
  data() {
    return {
      selected: null,
      results: [],
      communeTemplate: CommuneTemplate
    }
  },
  methods: {
    getLabel(item) {
      return item ? item.nom : ''
    },
    getSelectedId() {
      if(this.selected === null){
        this.$notify({
          group: 'general-notification',
          type: 'error',
          text: 'Une erreur est survenue lors de la recherche de la commune'
        })
      }
      return this.selected.id;
    },
    search(text) {
      axios.get('/antenniste/commune', {
        params: {
          limit: 20,
          nom: text
        }
      }).then((response) => {
        if(response.data.data.length === 0){
          this.selected = null
          this.$notify({
            group: 'general-notification',
            type: 'error',
            text: 'Une erreur est survenue lors de la recherche de la commune'
          })
        } else if (response.data.data) {
          this.results = response.data.data
        }
      }).catch(function(error) {
        this.selected = null
        this.$notify({
          group: 'general-notification',
          type: 'error',
          text: 'Une erreur est survenue lors de la recherche de la commune'
        })
        console.error('communes', error)
      })
    },
    communeSelected(commune) {
      // On agit directement
      this.selected = commune
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
